<script>
import {
  addressLadSelectorEmits,
  addressLadSelectorProps,
  useAdressLadSelector
} from "./mixin";
import Button from "@/components/atoms/button";
import Form from "@/components/molecules/form";
import ButtonIcon from "@/components/molecules/button-icon";
import Card from "@/components/molecules/card";
import FormRadio from "@/components/molecules/form-radio";
import FormFieldset from "@/components/molecules/form-fieldset";
import FormLegend from "@/components/molecules/form-fieldset/legend";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import PopinAnchor from "@/components/molecules/popin-anchor";
import AdresseLadRecap from "@/components/organisms/adresse-lad-recap-livreur";

export default {
  name: "AddressLadSelector",
  components: {
    Button,
    ButtonIcon,
    Card,
    Form,
    FormRadio,
    FormFieldset,
    FormLegend,
    GridCol,
    GridRow,
    PopinAnchor,
    AdresseLadRecap
  },
  props: {
    ...addressLadSelectorProps()
  },
  emits: addressLadSelectorEmits(),
  setup(props, context) {
    const {
      selectedAdressId,
      defaultAddress,
      otherAddresses,
      unavalaibleAddresses,
      adressSelected,
      resetAdress,
      addAddress,
      editAddress
    } = useAdressLadSelector(props, context);

    return {
      selectedAdressId,
      defaultAddress,
      otherAddresses,
      unavalaibleAddresses,
      adressSelected,
      resetAdress,
      addAddress,
      editAddress
    };
  }
};
</script>

<template>
  <div>
    <template v-if="adressesLad.length === 0">
      <div class="u-text-center u-mt-md u-mb-lg">
        <p class="u-font-18 u-font-secondary u-font-700 u-mb-md">
          Vous n'avez pas encore enregistré d'adresse de livraison
        </p>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          @click="addAddress()"
        >
          Je saisis mon adresse de livraison
        </Button>
      </div>
    </template>

    <template v-if="adressesLad.length > 0 && !selectedAddress">
      <Form class="c-form u-pl-md u-pr-md">
        <p class="u-font-14 u-color-grey-1 u-mb-xs25">
          Merci de choisir votre adresse de livraison
        </p>
        <FormFieldset
          v-if="defaultAddress"
          class="u-mb-lg"
        >
          <FormLegend
            variant="dotted"
            class="u-mb-sm"
          >
            Votre adresse habituelle
          </FormLegend>
          <GridRow class="u-flex-justify-start">
            <GridCol class="o-col--6">
              <FormRadio
                v-model="selectedAdressId"
                name="address"
                block
                :value="defaultAddress.id"
              >
                <span>
                  <template v-if="defaultAddress.attributes.libelle">
                    <strong>{{ defaultAddress.attributes.libelle }}</strong>
                    <br />
                  </template>
                  {{ defaultAddress.attributes.prenom }}
                  {{ defaultAddress.attributes.nom }}<br />
                  {{ defaultAddress.attributes.adresse }}<br />
                  <template v-if="defaultAddress.attributes.complement_adresse">
                    {{ defaultAddress.attributes.complement_adresse }}<br />
                  </template>
                  {{ defaultAddress.attributes.code_postal }}
                  {{ defaultAddress.attributes.nom_commune }}
                </span>
                <template #action>
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="grey-9"
                    :aria-label="
                      `Modifier l'adresse : ${defaultAddress.attributes.libelle}`
                    "
                    @click="editAddress(defaultAddress.id)"
                  />
                </template>
              </FormRadio>
            </GridCol>
          </GridRow>
        </FormFieldset>

        <FormFieldset class="u-mb-xlg">
          <FormLegend
            variant="dotted"
            class="u-mb-sm"
          >
            <template v-if="defaultAddress">
              Vos autres adresses
            </template>
            <template v-else>
              Vos adresses de livraison
            </template>
          </FormLegend>

          <GridRow
            v-if="otherAddresses.length > 0"
            class="u-mb-md"
          >
            <GridCol
              v-for="address in otherAddresses"
              :key="address.id"
              class="o-col--6"
            >
              <FormRadio
                v-model="selectedAdressId"
                name="address"
                block
                :value="address.id"
                class="u-mb-sm"
              >
                <p>
                  <template v-if="address.attributes.libelle">
                    <strong>{{ address.attributes.libelle }}</strong> <br />
                  </template>
                  {{ address.attributes.prenom }} {{ address.attributes.nom
                  }}<br />
                  {{ address.attributes.adresse }}<br />
                  <template v-if="address.attributes.complement_adresse">
                    {{ address.attributes.complement_adresse }}<br />
                  </template>
                  {{ address.attributes.code_postal }}
                  {{ address.attributes.nom_commune }}
                </p>
                <template #action>
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="grey-9"
                    :aria-label="
                      `Modifier l'adresse : ${address.attributes.libelle}`
                    "
                    @click="editAddress(address.id)"
                  />
                </template>
              </FormRadio>
            </GridCol>
          </GridRow>
          <GridRow class="u-flex-justify-start">
            <GridCol
              v-for="(address, index) in unavalaibleAddresses"
              :key="address.id"
              class="o-col--6"
            >
              <FormRadio
                name="address"
                disabled
                block
                :class="index > 0 && 'u-mb-sm'"
              >
                <p>
                  <template v-if="address.attributes.libelle">
                    <strong>{{ address.attributes.libelle }}</strong> <br />
                  </template>
                  {{ address.attributes.prenom }} {{ address.attributes.nom
                  }}<br />
                  {{ address.attributes.adresse }}<br />
                  <template v-if="address.attributes.complement_adresse">
                    {{ address.attributes.complement_adresse }}<br />
                  </template>
                  {{ address.attributes.code_postal }}
                  {{ address.attributes.nom_commune }}
                </p>
                <template #action>
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="grey-9"
                    :aria-label="
                      `Modifier l'adresse : ${address.attributes.libelle}`
                    "
                    @click="editAddress(address.id)"
                  />
                </template>
              </FormRadio>
              <p
                v-if="index === 0"
                class="u-font-14 u-mt-xxs u-mr-xlg  u-pr-xlg u-pr-none@lg u-mb-sm"
              >
                Cette adresse ne peut pas être livrée par le magasin Cora
                {{ magasinName }}.
              </p>
            </GridCol>
            <GridCol
              cols="5"
              class="u-flex u-mt-lg u-flex-align-start u-flex-justify-center u-pr-xlg u-pr-xs@lg"
            >
              <ButtonIcon
                v-if="canAdd"
                icon-name="more"
                link
                icon-color="grey-9"
                @click="addAddress()"
              >
                <span class="u-font-14">
                  Ajouter une adresse de livraison
                </span>
              </ButtonIcon>
            </GridCol>
          </GridRow>
        </FormFieldset>
        <div class="u-text-center u-mt-md u-mb-lg">
          <Button
            variant="secondary"
            radius="full"
            size="md"
            :disabled="!selectedAdressId"
            @click="adressSelected()"
          >
            Je valide cette adresse
          </Button>
        </div>
      </Form>
    </template>

    <template v-if="selectedAddress">
      <Card variant="grey-7">
        <div class="c-shipping-address">
          <p class="c-shipping-address__title">
            <strong class="u-mr-lg">Votre adresse de livraison</strong>
            <Button
              class="c-shipping-address__button"
              variant="link"
              @click="resetAdress()"
            >
              Choisir une autre adresse
            </Button>
          </p>
          <div class="c-shipping-address__address">
            <p class="c-shipping-address__address-title">
              <strong
                v-if="selectedAddress.attributes.libelle"
                class="u-mr-sm"
              >
                {{ selectedAddress.attributes.libelle }} :
              </strong>
              <Button
                class="c-shipping-address__button"
                variant="link"
                @click="editAddress(selectedAddress.id)"
              >
                Éditer cette adresse
              </Button>
            </p>
            <p class="c-shipping-address__address-val">
              {{ selectedAddress.attributes.prenom }}
              {{ selectedAddress.attributes.nom }}<br />
              {{ selectedAddress.attributes.adresse }}<br />
              <template v-if="selectedAddress.attributes.complement_adresse">
                {{ selectedAddress.attributes.complement_adresse }}<br />
              </template>
              {{ selectedAddress.attributes.code_postal }}
              {{ selectedAddress.attributes.nom_commune }}
            </p>
          </div>
          <PopinAnchor
            link
            popin-size="md"
            aria-label="Indications pour le livreur"
          >
            <template #button-content>
              <p class="u-font-14">
                Voir les indications pour le livreur
              </p>
            </template>
            <AdresseLadRecap :adresse-lad="selectedAddress" />
            <Button
              variant="link"
              class="u-mt-md u-mb-xs"
              @click="editAddress(selectedAddress.id)"
            >
              Modifier
            </Button>
          </PopinAnchor>
        </div>
      </Card>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address.scss";
.c-shipping-address-complement {
  line-height: 2.2rem;
}
</style>
